import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sas-management-forgot-password',
  templateUrl: './sas-management-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-management-forgot-password.component.css',
  ],
})
export class SasManagementForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/sas-management/images/logo.svg'
    );
  }
}
